module.exports = __webpack_public_path__ + "static/media/Mask Group 23.43d98b56.svg";